// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 480px) {\n.medical-analyse-form-action .c-button {\n    width: 30px;\n    height: 30px;\n}\n.medical-analyse-form-action .c-button-icon {\n    margin: 0 -4px !important;\n}\n.medical-analyse-form-action .c-button-label {\n    display: none !important;\n}\n.medical-comment-input {\n    margin-bottom: 80px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
